export default [
  {
    key: 'actions'
  },
  {
    key: 'status'   
  },
  {
    key: 'transaction_type'
  },
  {
    key: 'sale_type'
  },
  {
    key: 'units'
  },
  {
    key: 'listing_date'
  },
  {
    key: 'contract_date',
  },
  {
    key: 'target_mls_date'
  },
  {
    key: 'active_date'
  },
  {
    key: 'close_date'
  },
  {
    key: 'listing_price'
  },
  {
    key: 'sale_price'
  },
  {
    key: 'gross_commission'
  },
  {
    key: 'net_commission'
  }
];